module.exports = __webpack_public_path__ + "assets/img/timeStampCamera.56bd788d.png";